// extracted by mini-css-extract-plugin
export default {"zetony":"ZetonyWidoku_zetony__hNYLH","zeton":"ZetonyWidoku_zeton__IrjKx","zetonAktywny":"ZetonyWidoku_zetonAktywny__Pe1L7","licznik":"ZetonyWidoku_licznik__M+UUO"};